<template>
  <div class="margin-70">
    <dv-border-box-12 class="operaBox flex flex-direction justify-center padding-sm margin-top-sm">
      <div
        class="operation flex align-center justify-center"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-right-sm">
          <img class="operateIcon" :src="item.img" />
          <img
            class="right-icon margin-left-sm"
            src="@/assets/images/site/tri.png"
          >
        </div>
        <div class="flex flex-direction text-box">
          <p class="text-xss">{{item.text}}</p>
          <p class="text-sm DS-font margin-top-sm" style="word-break: break-all;">{{item.number}}</p>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
// 综合态势--动态渲染图片
import overview1 from "@/assets/images/index/overview3.png";
import overview2 from "@/assets/images/site/statinTimepng.png";
import overview3 from "@/assets/images/site/station-day.png";
import overview4 from "@/assets/images/index/overview2.png";
import overview5 from "@/assets/images/site/stationCar.png";

import { siteLeft } from "@/api/singleSite/left";
import {formatTime} from '@/utils/index'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      options: {},
      overviewList: [
        {
          text: "电池编号",
          number: "",
          img: overview4,
        },
        {
          text: "生产商",
          number: "",
          img: overview5,
        },
        {
          text: "业务类型",
          number: "",
          img: overview2,
        },
        {
          text: "创建日期",
          number: "",
          img: overview1,
        }
      ],
    };
  },
  components: {},
  props: {
    batteryInfo: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {
  },
  methods: {
    getData(data){
      this.dianchijibenxinxi(data);
    },
    dianchijibenxinxi(data){
      let params = {
        "enCode":"TiDB-dianchixiang-dianchixinxi",
        "@battery_id":data.batteryId
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          // 充电状态2-充电；3-充电完成
          let info = res[0];
            this.overviewList= [
              {
                text: "电池编号",
                number: data.battery_id,
                img: overview4,
              },
              {
                text: "生产商",
                number: info.manufacturer_name,
                img: overview5,
              },
              {
                text: "电池类型",
                number: info.battery_type,
                img: overview2,
              },
              {
                text: "创建日期",
                number: info.create_time,
                img: overview1,
              }
            ]
        })
        .catch((err) => {
          console.log(err);
        });
    }
    
  },
};
</script>
<style lang="scss" scoped>
.margin-70 {
  margin: 70px;
  margin-bottom: 0;
}
.operaBox {
  width: 370px;
}
.operation {
  height: 144px;
}
.operation-icon {
  width: 82px;
  height: 72px;
}
.right-icon {
  width: 14px;
  height: 16px;
}
.text-box {
  width: 140px;
}
.DS-font {
  line-height: 24px;
  font-family: "DS-Digital-Bold";
}
.operateIcon{
  width:82px;
}
</style>